import React from 'react';
import PropTypes from 'prop-types';
import CanvasJSChart from '../../../../assets/CanvasJSChart';

const SmallDevelopmentChart = ({ chartData }) => {
  const data = [
    {
      dataPoints: chartData,
      color: '#F24D00',
      markerSize: 0,
      markerType: 'none',
      type: 'line',
      lineThickness: 1,
    },
  ];

  let yMin = null;
  let yMax = null;

  chartData.forEach((line) => {
    if (yMin == null || (line.y < yMin && line.y !== null)) {
      yMin = line.y;
    }
    if (line.y > yMax) {
      yMax = line.y;
    }
  });

  const options = {
    animationEnabled: false,
    axisY: {
      title: '',
      tickLength: 0,
      lineThickness: 0,
      gridThickness: 0,
      margin: 0,
      valueFormatString: ' ',
      minimum: yMin - (yMin*0.005),
      maximum: yMax + (yMax*0.005),
    },
    axisX: {
      minimum: 0,
      includeZero: true,
      title: '',
      tickLength: 0,
      gridThickness: 0,
      margin: 0,
      lineThickness: 0,
      valueFormatString: ' ',
    },
    toolTip: {
      enabled: false,
    },
    data: data,
    height: 35,
    backgroundColor: 'transparent',
  };

  return <CanvasJSChart options={options} />;
};

SmallDevelopmentChart.propTypes = {
  chartData: PropTypes.array,
};

export default SmallDevelopmentChart;
